import { render, staticRenderFns } from "./FuelTabComponent.vue?vue&type=template&id=3af3bc66&scoped=true"
import script from "./FuelTabComponent.js?vue&type=script&lang=js&external"
export * from "./FuelTabComponent.js?vue&type=script&lang=js&external"
import style0 from "./FuelTabComponent.vue?vue&type=style&index=0&id=3af3bc66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af3bc66",
  null
  
)

export default component.exports